import { Icon } from "simplydo/react/ui";

import { crunchbaseImageUrl } from "utils/companies";

import type { CompanyAcquisition } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
} from "../Styles";

type CompanyAcquisitionsProps = { acquisitions: CompanyAcquisition[] };

const CompanyAcquisitions = ({ acquisitions }: CompanyAcquisitionsProps) => {
  if (acquisitions.length) {
    return (
      <InfoBoxWidget $noBox style={{ maxHeight: 520, overflow: "auto" }}>
        <InfoBoxWidgetTitleArea>
          <Icon name="shop" />
          <div>
            <h3>Acquisitions</h3>
            <span>{acquisitions.length} found</span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          {acquisitions.map((acquisition) => (
            <InfoItem
              $compact
              key={
                acquisition.acquiree_identifier?.uuid ??
                acquisition.identifier?.uuid
              }
            >
              <KeyFactLink
                image={`${crunchbaseImageUrl}${acquisition.acquiree_identifier?.image_id ?? ""}`}
                title={acquisition.acquiree_identifier?.value ?? "Unknown"}
                fact={acquisition.short_description ?? ""}
              />
            </InfoItem>
          ))}
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyAcquisitions;
